import api from './api';

/**
 * Get all feedback with optional filters
 * @param {Object} params - Query parameters
 * @returns {Promise<Object>} Feedback list with pagination
 */
export const getFeedback = async (params = {}) => {
  const response = await api.get('/admin/feedback', { params });
  return response.data;
};

/**
 * Get feedback statistics
 * @returns {Promise<Object>} Feedback stats
 */
export const getFeedbackStats = async () => {
  const response = await api.get('/admin/feedback/stats');
  return response.data;
};

/**
 * Get a single feedback by ID
 * @param {number} id - Feedback ID
 * @returns {Promise<Object>} Feedback object
 */
export const getFeedbackById = async (id) => {
  const response = await api.get(`/admin/feedback/${id}`);
  return response.data;
};

/**
 * Mark feedback as read
 * @param {number} id - Feedback ID
 * @returns {Promise<Object>} Updated feedback
 */
export const markAsRead = async (id) => {
  const response = await api.put(`/admin/feedback/${id}/read`);
  return response.data;
};

/**
 * Mark feedback as responded
 * @param {number} id - Feedback ID
 * @returns {Promise<Object>} Updated feedback
 */
export const markAsResponded = async (id) => {
  const response = await api.put(`/admin/feedback/${id}/responded`);
  return response.data;
};

/**
 * Delete feedback
 * @param {number} id - Feedback ID
 * @returns {Promise<Object>} Deletion result
 */
export const deleteFeedback = async (id) => {
  const response = await api.delete(`/admin/feedback/${id}`);
  return response.data;
};

const feedbackService = {
  getFeedback,
  getFeedbackStats,
  getFeedbackById,
  markAsRead,
  markAsResponded,
  deleteFeedback
};

export default feedbackService;

